/**
 * 앱 업데이트 요청 판단 (2026-10-09): 예전에는 설정 파일 버전과 '다르기만 하면' 업데이트 요청 창(종료 버튼만)을 띄워서,
 * 애플 심사관이 받은 새 빌드(설정 파일보다 높은 버전)가 첫 화면에서 막혀 거절됐다 (2023-03, 가이드라인 2.1).
 * 이제는 설치된 버전이 요구 버전보다 낮을 때만 요청한다.
 */
export function isOlderVersion(installed: string | undefined | null, required: string | undefined | null): boolean {
  if (!installed || !required) return false;
  const a = String(installed).split(/[^0-9]+/).filter(Boolean).map(Number);
  const b = String(required).split(/[^0-9]+/).filter(Boolean).map(Number);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const x = a[i] ?? 0, y = b[i] ?? 0;
    if (x !== y) return x < y;
  }
  return false;
}
